<template>
    <v-toolbar app color="darken-4 blue-grey" :class="[drawer && 'pl-260']" dark fixed>
        <v-toolbar-title class="ml-0">
            <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        </v-toolbar-title>
        <v-dialog max-width="400px" v-model="dialog">
            <v-card class="dialog-change-password">
                <v-card-title class="headline grey lighten-2" primary-title>Change Your Password</v-card-title>
                <v-form ref="formReset" data-vv-scope="formReset" v-model="vFormReset" lazy-validation>
                    <v-card-text class="pa-0">
                        <v-container grid-list-md pb-0 pt-0>
                            <v-text-field
                                        :error-messages="errors.collect('formReset.password')"
                                        data-vv-name="password"
                                        label="Current Password"
                                        type="password"
                                        v-model="editedItem.password"
                                        v-validate="{required: true, max:50, min:6}"
                                        required
                            ></v-text-field>
                            <v-text-field
                                :error-messages="errors.collect('formReset.new_password')"
                                data-vv-name="new_password"
                                label="New Password"
                                ref="new_password"
                                type="password"
                                v-model="editedItem.new_password"
                                v-validate="{required: true, max:50, min:6}"
                                required
                            ></v-text-field>
                            <v-text-field
                                :error-messages="errors.collect('formReset.comfirm_password')"
                                data-vv-as="comfirm_password"
                                label="Confirm Password"
                                name="comfirm_password"
                                type="password"
                                v-model="editedItem.comfirm_password"
                                v-validate="{required: true, max:50, min:6, confirmed: editedItem.new_password}"
                                required
                            ></v-text-field>
                            <p style="color: #FF5E44;font-size: 12px;">{{error_message}}</p>
                        </v-container>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="changePass" style="width: 86px" :disabled="!vFormReset" color="primary">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog max-width="450px" v-model="dialogConfirm" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Alert</span>
                </v-card-title>
                <v-card-text style="color: #4caf50; text-align: center">{{ res_msg }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!--<v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
                    <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>-->
                    <v-btn @click="close" color="primary" style="width: 85px">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-menu :nudge-bottom="12" :nudge-righ="10" left offset-y origin="center center" transition="scale-transition">
            <span class="avatar" slot="activator">{{currentUser? currentUser.first_name[0]: ''}}</span>
            <v-list class="list-menu-account">
                <v-list-tile
                    :disabled="item.disabled"
                    :href="item.href !== '' ? item.href : null"
                    :key="index"
                    :target="item.target"
                    :to="!item.href ? { name: item.name } : null"
                    @click="item.click"
                    rel="noopener"
                    ripple="ripple"
                    v-for="(item,index) in items"
                >
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-toolbar>
</template>
<script>
import Util from "@/util";
import Sha256 from "sha256";
export default {
    name: "app-toolbar",
    inject: ["$validator"],
    data() {
        return {
            items: [
                {
                    icon: "account_circle",
                    href: "",
                    title: "Profile",
                    click: () => {
                        this.$router.push({ name: 'Profile'});
                    }
                },/*
                {
                    icon: "account_circle",
                    href: "#",
                    title: "Change password",
                    click: e => {
                        this.dialog = true;
                    }
                },*/
                {
                    icon: "fullscreen_exit",
                    href: "#",
                    title: "Logout",
                    click: () => {
                        this.$store.dispatch("auth/logout");
                    }
                }
            ],
            dictionary: {
                custom: {
                    password: {
                        required: "It is required",
                        max: "Max 50 characters",
                        min: "Min 6 characters"
                    },
                    new_password: {
                        required: "It is required",
                        max: "Max 50 characters",
                        min: "Min 6 characters"
                    },
                    comfirm_password: {
                        required: "It is required",
                        max: "Max 50 characters",
                        min: "Min 6 characters",
                        confirmed: "Confirm Password wrong"
                    }
                }
            },
            error_message: "",
            editedItem: {
                password: "",
                new_password: "",
                comfirm_password: ""
            },
            dialog: false,
            vFormReset: false,
            disableBtn: false,
            res_msg: '',
            dialogConfirm: false
        };
    },
    created() {
        this.$store.dispatch("auth/setCurrentUser");
    },
    updated() {
        if (!this.disableBtn) {
            this.dialog = (this.currentUser && this.currentUser.reset_pwd);
        }
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    watch: {
        formReset: {
            handler() {
                this.error_message = '';
            },
            deep: true
        },
        editedItem: {
            handler() {
                this.error_message = '';
            },
            deep: true
        }
    },
    computed: {
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        currentUser() {
            return this.$store.getters["auth/currentUser"];
        },
        drawer() {
            return this.$store.getters["common/getDrawerTogged"];
        },
    },
    methods: {
        handleDrawerToggle() {
            this.$store.dispatch("common/setDrawerTogged");
        },
        handleFullScreen() {
            Util.toggleFullScreen();
        },
        changePass() {
            this.$validator.validate('formReset.*').then(result => {
                if (result) {
                    let params = {
                        old_pass: Sha256(this.editedItem.password),
                        new_pass: Sha256(this.editedItem.new_password)
                    };
                    this.axios
                        .put("/users/password/change", params)
                        .then(res => {
                            if (res.data && res.data.statusCode === 200) {
                                // this.$store.dispatch("auth/setCurrentUser");
                                this.res_msg = res.data.message;
                                this.error_message = '';
                                this.disableBtn = true;
                                this.dialogConfirm = true;
                            } else {
                                this.error_message = res.data.message;
                            }

                        });
                }
            });
        },
        close() {
            this.dialog = false;
            this.dialogConfirm = false;
            this.$store.dispatch("auth/logout");
            /*this.editedItem = {
                password: "",
                new_password: "",
                comfirm_password: ""
            };*/
        }
    }
};
</script>
<style>
.avatar {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: #1e67be;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    font-size: 18px;
    text-transform: uppercase;
    cursor: pointer;
}
    .list-menu-account {
        width: 180px;
        padding: 10px 0;
    }
    /*.v-card__title {
        font-size: 18px;
        font-weight: bold;
        background-color: #f5f5f5;
    }*/
    .v-card__actions {
        padding: 15px 10px;
    }
    .dialog-change-password .v-card__title {
        font-size: 20px !important;
        font-weight: bold;
        padding: 16px;
    }
    .pl-260{
        padding-left: 260px !important;
    }
</style>
